/** @module csi/wizard/FinishController */
define([
	"dojo/_base/declare",
	"csi/action/ProxyController"
], function(declare,ProxyController) {

	return declare(ProxyController, {
		/**
		 * Call wizard to do any final processing
		 */
		process: function() {
			var self = this;

			this.when(this.validate(), function() {
				self.widget.finishPage();
				ProxyController.prototype.process.call(self);
			});
		}
	});
});